import React from "react";
import { faqs } from "../mock";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { HelpCircle } from "lucide-react";
import useReveal from "../hooks/useReveal";

export default function FAQ() {
  const ref = useReveal();
  return (
    <section id="faq" className="bg-white py-16">
      <div ref={ref} className="reveal mx-auto max-w-3xl px-4 lg:px-8">
        <div className="mb-8 flex flex-col items-center text-center">
          <span className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-sky text-navy">
            <HelpCircle size={24} />
          </span>
          <h2 className="font-heading text-2xl font-extrabold text-navy md:text-3xl">
            Frequently Asked Questions
          </h2>
          <p className="mt-2 text-sm text-navy/60">
            Everything you need to know before you buy from Cyberfit.
          </p>
        </div>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="mb-3 overflow-hidden rounded-xl border border-navy/10 bg-gray-50 px-5"
            >
              <AccordionTrigger className="py-4 text-left font-heading text-base font-bold text-navy hover:text-brand hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-4 text-sm leading-relaxed text-navy/70">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <div className="mt-8 rounded-2xl bg-navy p-6 text-center text-white">
          <p className="font-heading text-lg font-bold">Still have questions?</p>
          <p className="mt-1 text-sm text-white/70">Our Australian team is here to help 7 days a week.</p>
          <a
            href="tel:+61296206635"
            className="mt-4 inline-flex items-center gap-2 rounded-full bg-brand px-8 py-3 font-heading font-bold text-white transition-colors hover:bg-brand-dark"
          >
            Call 02 9620 6635
          </a>
        </div>
      </div>
    </section>
  );
}
